



import { useNavigate, useParams } from "react-router-dom";
import Login from '../../components/falta1/login'
import React, { useEffect, useState } from "react";


export default function Paginas() {
    const navigate = useNavigate();
    const [loginVisible, setLoginvisible] = useState(false)

    useEffect(() => {
      
        const loggedUserJSON = window.localStorage.getItem('loggedNoteAppUser')
        console.log(loggedUserJSON) 
        if (loggedUserJSON) {
          const user = JSON.parse(loggedUserJSON)
       
          switch (user.nivel) {
            case 1:
              navigate('/falta1/principal')
           //   navigate('/')
              break;
           
            default:
              window.localStorage.removeItem('loggedNoteAppUser')
              navigate('/falta1/login')
              
              break;
          }
        }
        setLoginvisible(true)
      }, [])

    return (
        <>
        {loginVisible ? <>
   
        <Login/>
        </>:<></>}
        </>
   
    );

}